function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import { withReactBootstrap } from "@demant/react-bootstrap";
var TabBar = function TabBar(_ref) {
  var tabs = _ref.tabs,
    isDesktop = _ref.isDesktop;
  var _useState = useState(tabs[0]),
    _useState2 = _slicedToArray(_useState, 2),
    currentTab = _useState2[0],
    setCurrentTab = _useState2[1];
  var scroller = useRef(null);
  var handleScrollClick = function handleScrollClick(value) {
    scroller.current.scrollTo(scroller.current.scrollLeft + 10 * value, 0);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "cg__tab-bar"
  }, !isDesktop && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "cg__tab-bar__back",
    onClick: function onClick() {
      handleScrollClick(-1);
    }
  }), /*#__PURE__*/React.createElement("div", {
    ref: scroller,
    className: "cg__tab-bar__scroll"
  }, tabs.map(function (tab) {
    return /*#__PURE__*/React.createElement("a", {
      key: tab.label,
      href: tab.link,
      className: currentTab.link === tab.link ? "current" : "",
      title: tab.label,
      onClick: function onClick() {
        setCurrentTab(tab);
      }
    }, tab.label);
  })), !isDesktop && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "cg__tab-bar__forward",
    onClick: function onClick() {
      handleScrollClick(1);
    }
  }));
};
TabBar.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.shape({
    link: PropTypes.string,
    label: PropTypes.string
  })).isRequired,
  isDesktop: PropTypes.bool.isRequired
};
export default withReactBootstrap(TabBar);